import { NextPage } from "next";
import { Typography, useMediaQuery } from "@mui/material";
import { BoxColumn } from "../../components/common/Boxes";
import { PageHead } from "../../components/PageHead";

const exampleImages = [
  "runes_cardgame_card_ravemage_alternate.png",
  "runes_cardgame_card_chronomeer_betatesterreward.gif"
];

const WhatIsRunes: NextPage = () => {
  const isMobileView = useMediaQuery("(max-width:600px)");
  return (
    <>
      <PageHead />
      <BoxColumn sx={{ p: 2, overflowY: "auto", alignItems: "center" }}>
        <BoxColumn sx={{ width: 800, maxWidth: "100%", gap: 2, px: 4 }}>
          <Typography variant="h2">What is Runes?</Typography>
          <Typography
            variant="h6"
            style={{ whiteSpace: "pre-line", fontFamily: "Mooli" }}
          >
            Runes is a trading card game set in the Runiverse, the world being
            realized by the Forgotten Runes Wizard Cult team & community.
          </Typography>
          <div
            style={{
              width: "100%",
              justifyContent: "center",
              display: "flex"
            }}
          >
            <img src={`/cards/${exampleImages[0]}`} width="250" height="333" />
          </div>
          <Typography
            variant="h6"
            style={{ whiteSpace: "pre-line", fontFamily: "Mooli" }}
          >
            Runes is a game with fun, easy to grasp, and engaging gameplay. It
            has a major focus on co-authoring & storytelling. We want to be a
            platform that allows people to be able to create the experiences
            they want to create, for themselves and others. We draw heavily on
            years & years of Magic The Gathering experiences where some of the
            most fulfilling and rewarding aspects were assembling the perfect
            deck from cards, to sleeves, to playmat, to custom art. This is also
            very much the mantra of Forgotten Runes Wizards Cult, where
            derivatives are held in high esteem and the community is not only
            given the freedom to, but encouraged to tell their own stories and
            help create the world around them.
          </Typography>

          <div
            style={{
              width: "100%",
              justifyContent: "center",
              display: "flex"
            }}
          >
            <img src={`/cards/${exampleImages[1]}`} width="250" height="333" />
          </div>
          <Typography
            variant="h6"
            style={{ whiteSpace: "pre-line", fontFamily: "Mooli" }}
          >
            On the surface - Runes is a 1v1 card game where players battle each
            other using cards, represented as NFTs, that they’ve collected
            through playing the game or exclusive gifts.
            {"\n"}
            {"\n"}
            Digging deeper - Runes is a complete multimedia experience where
            social, gameplay, and creator cultures collide. It is a malleable
            portal that gives players the tools they need to transport
            themselves & friends (or strangers) into a setting of their
            choosing.
            {"\n"}
            {"\n"}
            Here is a lore reading given by the founder giveahoot at a 2021
            Wizard Wednesday.
            {"\n"}
            {"\n"}
          </Typography>

          <iframe
            // width={isMobileView ? "100%" : "560"}
            // height={isMobileView ? "200px" : "400px"}
            // height="500"
            style={{
              width: "100%",
              aspectRatio: "16/9"
            }}
            src="https://www.youtube.com/embed/o8k4JLqyyII?start=2448"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </BoxColumn>
      </BoxColumn>
    </>
  );
};

export default WhatIsRunes;
